const DOT_DELAYS_MS = [0, 150, 300];

/** Three bouncing dots shown while the assistant is preparing its answer. */
export const TypingIndicator: React.FC = () => (
  <div className="flex justify-start" role="status" aria-label="Assistant is typing">
    <div className="flex items-center gap-1 rounded-lg bg-slate-100 px-3 py-3 dark:bg-slate-700">
      {DOT_DELAYS_MS.map((delay) => (
        <span
          key={delay}
          className="h-1.5 w-1.5 animate-bounce rounded-full bg-slate-400 dark:bg-slate-300"
          style={{ animationDelay: `${delay}ms` }}
        />
      ))}
    </div>
  </div>
);
